$('#aboutProductList').slick({
    mobileFirst: true,
    variableWidth: false,
    dots: true,
    arrows: true,
    speed: 300,
    centerMode: false,
    slidesToShow: 1,
    initialSlide: 0,
    infinite: true,
    prevArrow: '<div class="slick-prev slick-arrow"><svg class="icon"><use xlink:href="svg/sprite.svg#ARROW"/></svg></div>',
    nextArrow: '<div class="slick-next slick-arrow"><svg class="icon"><use xlink:href="svg/sprite.svg#ARROW"/></svg></div>',
    responsive: [
        {
            breakpoint: 767,
            settings: "unslick"
        }
    ]
});